import { render, staticRenderFns } from "./Coaching.vue?vue&type=template&id=719452ae&scoped=true"
import script from "./Coaching.vue?vue&type=script&lang=js"
export * from "./Coaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719452ae",
  null
  
)

export default component.exports